<dx-tag-box [dataSource]="resourcesList"
            displayExpr="name"
            valueExpr="resourceId"
            [searchEnabled]="true"
            placeholder="Búsqueda por recursos"
            [showSelectionControls]="true"
            selectAllText="Seleccionar todos"
            [readOnly]="tagBoxEnabled"
            [disabled]="tagBoxEnabled"
            (onValueChanged)="onResourcesChanged($event)"
            [dropDownOptions]="{minWidth: '500px'}"
>
</dx-tag-box>
